import { ManfrediteOfferFilterResponse } from '@asgard/api-common';
import { MultilingualLanguages } from '@asgard/common-dto';
import { ManfrediteOfferAlert } from 'model/model-manfredite-offer-alert';
import { CommonDtoLevelToLanguageLevelDict } from './service.language.normalizer';

export const normalizeToManfrediteOfferAlerts = (
  res: ManfrediteOfferFilterResponse[],
  lang: MultilingualLanguages
): ManfrediteOfferAlert[] =>
  res.map((item) => normalizeToManfrediteOfferAlert(item, lang));

export const normalizeToManfrediteOfferAlert = (
  res: ManfrediteOfferFilterResponse,
  // eslint-disable-next-line unused-imports/no-unused-vars
  lang: MultilingualLanguages
): ManfrediteOfferAlert => ({
  id: res.id,
  createdAt: new Date(res.createdAt).toISOString(),
  filter: {
    onlyActive: true,
    remoteOptions: (res.criteria.remoteOptions as string[]) || [],
    techs: res.criteria.techs.map((tech) => tech.id) || [],
    techRoles: res.criteria.techRoles.map((tech) => tech.id) || [],
    locations: res.criteria.locations.map((location) => ({
      placeId: location.placeId,
      displayName: location.displayName
    })),
    currency: res.criteria.currency || '€',
    minSalary: res.criteria.minSalary?.toString() || '',
    offerLanguage: res.criteria.offerLanguage || '',
    text: res.criteria.text || '',
    minLanguages:
      res.criteria.minLanguages?.map((minLang) => ({
        id: minLang.id,
        language: {
          label: minLang.name,
          value: minLang.id
        },
        level: {
          label:
            CommonDtoLevelToLanguageLevelDict[minLang.level || 'Undefined'] ||
            'not-defined',
          value:
            CommonDtoLevelToLanguageLevelDict[minLang.level || 'Undefined'] ||
            'not-defined'
        }
      })) || []
  }
});
